export const compareValeus = (value1: string, value2: string) => value1.toUpperCase()
  .replaceAll(' ', '')
  .includes(value2.replaceAll(' ', '').toUpperCase());
